// Eagerly load the sidebar bundle so styles resolve at compile time —
// avoids cascade races introduced by code-splitting + the runtime
// `@import url(...)` chain inside main.scss. Behaviour matches the legacy
// flat Sidebar.js, which imported the same bundle.
import "../../assets/css/sidebar-bundle.scss";

import React, { memo } from "react";

import { useSidebar } from "./useSidebar";
import sidebarMenuConfig from "./sidebarMenuConfig";

import LogoBlock from "./components/LogoBlock";
import CollapseToggle from "./components/CollapseToggle";
import MenuSection from "./components/MenuSection";
import LogoutButton from "./components/LogoutButton";
import LogoutModal from "./components/LogoutModal";
import SessionExpiredModal from "./components/SessionExpiredModal";
import useSidebarMenuConfig from "./sidebarMenuConfig";

const Sidebar = ({ setLoggedIn }) => {
  const sb = useSidebar({ setLoggedIn });

  const {sidebarMenuConfig} = useSidebarMenuConfig()

  const ctx = {
    can: sb.can,
    canAny: sb.canAny,
    isMatch: sb.isMatch,
    isExpanded: sb.isExpanded,
    toggleSection: sb.toggleSection,
    counters: sb.counters,
    onSubItemNavigate: sb.onSubItemNavigate,
    handlers: sb.handlers,
    collapsed: sb.collapsed,
  };

  const visibleSections = sb.isEmployeeWalletOnly ? [] : sidebarMenuConfig;

  return (
    <>
      {sb.isPhone && sb.collapsed && (
        <button
          type="button"
          className="sb-sidebar-opener"
          onClick={sb.toggleCollapse}
          aria-label="Open menu"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      )}
    <aside
      className={
        sb.collapsed
          ? "sb-sidebar sb-sidebar--collapsed"
          : "sb-sidebar"
      }
      aria-label="Primary navigation"
    >
      <div className="sb-sidebar__header">
        <LogoBlock
          collapsed={sb.collapsed}
          companyLogo={sb.userData?.CompanyLogo}
          onLogoClick={sb.handleNavigate}
        />
        <CollapseToggle
          collapsed={sb.collapsed}
          onClick={sb.toggleCollapse}
        />
      </div>

      <nav className="sb-sidebar__nav" aria-label="Sidebar menu">
        {visibleSections?.map((section) => (
          <MenuSection key={section.key} section={section} ctx={ctx} />
        ))}
      </nav>

      <div className="sb-sidebar__footer">
        <LogoutButton
          collapsed={sb.collapsed}
          onClick={sb.openLogoutModal}
        />
      </div>

      <LogoutModal
        show={sb.logoutModalShow}
        onHide={sb.closeLogoutModal}
        onConfirm={sb.confirmLogout}
      />
      <SessionExpiredModal
        show={sb.sessionExpiredModalShow}
        onConfirm={sb.confirmLogout}
      />
    </aside>
    </>
  );
};

export default memo(Sidebar);
